import { Lightbulb } from "lucide-react";

/** Numbered step list. items: array of strings or React nodes. */
export const Steps = ({ items }) => (
  <ol style={{ listStyle: "none", padding: 0, marginTop: 14 }}>
    {items.map((step, i) => (
      <li
        key={i}
        style={{
          display: "flex",
          gap: 14,
          marginBottom: 12,
          padding: "12px 14px",
          background: "#FAFCFF",
          border: "1px solid #E2E8F0",
          borderRadius: 10,
        }}
      >
        <div
          style={{
            flexShrink: 0,
            width: 26,
            height: 26,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 12,
            fontWeight: 700,
            color: "#fff",
            background: "#0046BE",
          }}
        >
          {i + 1}
        </div>
        <div style={{ flex: 1, minWidth: 0, fontSize: 14, lineHeight: 1.65, color: "#475569" }}>
          {step}
        </div>
      </li>
    ))}
  </ol>
);

/** Blue-tinted tip callout. */
export const Tip = ({ children }) => (
  <div
    style={{
      display: "flex",
      gap: 12,
      padding: "14px 16px",
      borderRadius: 12,
      background: "#E8F0FE",
      border: "1px solid rgba(0, 70, 190, 0.18)",
      marginTop: 16,
    }}
  >
    <Lightbulb className="w-4 h-4 mt-0.5 shrink-0" style={{ color: "#0046BE" }} />
    <p style={{ margin: 0, fontSize: 14, lineHeight: 1.65, color: "#0F172A" }}>
      <strong style={{ color: "#0046BE" }}>Tip — </strong>
      {children}
    </p>
  </div>
);

/** Light data table. headers: string[], rows: (string|node)[][]. */
export const DocsTable = ({ headers, rows, testid }) => (
  <div className="overflow-x-auto mt-4 rounded-xl" data-testid={testid}>
    <table
      style={{
        width: "100%",
        minWidth: 600,
        borderCollapse: "separate",
        borderSpacing: 0,
        border: "1px solid #E2E8F0",
        borderRadius: 12,
        overflow: "hidden",
        background: "#fff",
      }}
    >
      <thead>
        <tr style={{ background: "#F4F7FC" }}>
          {headers.map((h, i) => (
            <th
              key={i}
              style={{
                textAlign: "left",
                padding: "11px 14px",
                fontSize: 11,
                color: "#64748B",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                fontWeight: 600,
                borderBottom: "1px solid #E2E8F0",
              }}
            >
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, ri) => (
          <tr key={ri}>
            {row.map((cell, ci) => (
              <td
                key={ci}
                style={{
                  padding: "11px 14px",
                  fontSize: 13,
                  borderBottom: "1px solid #F1F5F9",
                  color: ci === 0 ? "#0F172A" : "#475569",
                  fontWeight: ci === 0 ? 500 : 400,
                }}
              >
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
